/**
 * @license
 *-------------------------------------------------------------------------------------------
 * Copyright © 2025 Progress Software Corporation. All rights reserved.
 * Licensed under commercial license. See LICENSE.md in the package root for more information
 *-------------------------------------------------------------------------------------------
 */
var r = /* @__PURE__ */ ((c) => (c.head = "head", c.body = "body", c))(r || {}), o = /* @__PURE__ */ ((c) => (c.create = "create", c.edit = "edit", c.delete = "delete", c.select = "select", c.copySelection = "copySelection", c.copySelectionNoHeaders = "copySelectionNoHeaders", c.paste = "paste", c.reorderRow = "reorderRow", c.exportPDF = "exportPDF", c.exportExcel = "exportExcel", c.separator = "separator", c.sortAsc = "sortAsc", c.sortDesc = "sortDesc", c))(o || {});
export {
  r as GridContextMenuAnchorPart,
  o as GridContextMenuItemNames
};
